import { render, staticRenderFns } from "./billing-modal-invoice-receipt.vue?vue&type=template&id=8bf3d006&"
import script from "./billing-modal-invoice-receipt.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-invoice-receipt.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports